export default {"src":"https://fishbrain.com/_next/static/media/arrow-black.3cda80de.svg","height":18,"width":59,"blurWidth":0,"blurHeight":0};